export default "<div [style.color]=\"data.color\" [style.text-align]=\"data.textAlign\">{{data.msg | translate}}</div>\n"